import React from 'react';
import { useParams } from 'react-router-dom';
import Header from '../components/Header';
import MarkDown from '../components/MarkDown';
import Footer from '../components/Footer';
import '../blog.css';

function Manga() {
  const { id } = useParams();

  return (
    <div className="manga-page">
      <Header />
      <div className="cont2">
      <MarkDown path={`/manga/${id}`} type="manga" />
      <div className="return">
      </div>
      <a href="/manga">漫画一覧</a>
      </div>
      <Footer />
    </div>
  );
}

export default Manga;
